import { createClient } from '@supabase/supabase-js';
import { logger } from '../utils/logger';
import { Cliente, SupabaseResponse } from '../types';

// Configuração do Supabase
const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
const SUPABASE_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!SUPABASE_URL || !SUPABASE_KEY) {
  logger.error('ERRO: Variáveis de ambiente não configuradas!');
  throw new Error('Variáveis de ambiente do Supabase não configuradas. Verifique o arquivo .env');
}

export const supabase = createClient(SUPABASE_URL, SUPABASE_KEY);

export class ClienteService {

  // Método para buscar cliente por email
  static async buscarPorEmail(email: string): Promise<SupabaseResponse<Cliente[]>> {
    try {
      
      if (!email || email.trim() === '') {
        return { 
          data: null, 
          error: { message: 'Email não pode estar vazio' } 
        };
      }

      // Busca exata por email_cliente
      const { data, error } = await supabase
        .from('cliente')
        .select('*')
        .eq('email_cliente', email.trim());

      if (error) {
        logger.error('Erro na busca por email:', error);
        return { data: null, error };
      }

      if (!data || data.length === 0) {
        return { data: [], error: null };
      }
      return { data, error: null };
    } catch (error) {
      logger.error('Erro geral na busca:', error);
      return { data: null, error };
    }
  }

  // Método para buscar primeiro cliente por email
  static async buscarPrimeiroPorEmail(email: string): Promise<SupabaseResponse<Cliente>> {
    const response = await this.buscarPorEmail(email);
    
    if (response.error) {
      return { data: null, error: response.error };
    }

    if (!response.data || response.data.length === 0) {
      return { data: null, error: { message: 'Cliente não encontrado' } };
    }

    return { data: response.data[0], error: null };
  }


  // Método para buscar por nome (opcional)
  static async buscarPorNome(nome: string): Promise<SupabaseResponse<Cliente[]>> {
    try {
      
      if (!nome || nome.trim() === '') {
        return { 
          data: null, 
          error: { message: 'Nome não pode estar vazio' } 
        };
      }

      const { data, error } = await supabase
        .from('cliente')
        .select('*')
        .ilike('name_cliente', `%${nome.trim()}%`);

      if (error) {
        logger.error('Erro na busca por nome:', error);
        return { data: null, error };
      }

      return { data, error: null };
    } catch (error) {
      logger.error('Erro geral na busca por nome:', error);
      return { data: null, error };
    }
  }
}